<template>
    <div class="w-full flex flex-col gap-6 items-center pt-8 resourceContainer">
        <div class="flex flex-col px-4 items-center text-primary relative" v-if="isIndex">
            <img class="w-24 h-12 absolute bg" src="@/assets/title.png" />
            <div class="text-lg font-bold">资源平台</div>
            <div class="flex items-center gap-1">
                <div class="w-5 h-0.5 bg-primary" />
                <span class="text-xs font-semibold">Resouce platform</span>
                <div class="w-5 h-0.5 bg-primary" />
            </div>
        </div>
        <div class="flex flex-col gap-6 resourcePlatformContainer w-full px-4 pb-6">
            <div v-for="item in info" :key="item?.id" @click='() => handleNavigateToLink(item)'
                class="flex items-center gap-6 bg-white shadow-md p-4 rounded-sm" >
                <div>
                    <img class="w-10 h-10" :src="'/mainsys/UserFiles/externalicon/' + item?.linkImage" alt="" />
                </div>
                <div class="flex flex-col gap-2">
                    <div class="text-base font-bold">{{ item?.linkName }}</div>
                    <div class="text-base font-normal">{{ item?.linkDescription && item?.linkDescription!="null" ?item?.linkDescription:"" }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import mixins from '../hooks'

export default {
    props: {
        info: {
            default: () => []
        },
      isIndex: {
          default: false
      }
    },
    mixins: [mixins],
    data() {
        return {
            acticveId: '',
        }
    },
    watch: {
        info: {
            immediate: true,
            handler(newVal) {
                if (newVal?.length) {
                    this.acticveId = newVal[0]?.id
                }
            }
        }
    },
    methods: {
        // 菜单栏点击事件
        handleClickMenu(item) {
            if (this.acticveId === item?.id) {
                this.handleNavigateToLink(item);
            } else {
                this.acticveId = item?.id;
            }

        }
    },
};
</script>
<style scoped>
.bg {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1;
}

.contairesourceContainerner {
    background-color: #FAFAFA;
}

.resourcePlatformContainer {
    background-image: url("~@/assets/bg1.png");
    background-repeat: no-repeat;
}
</style>
